<template lang="">
  <div class="contents">
    <div class="user_login_wrap">
      <div class="login_txt">
        <h5>로그인</h5>
        <div>아직 <span>Blossom Logos</span>의 회원이 아니신가요?</div>
        <p>회원가입을 하시면 <span>Blossom Logos</span>의 <br> 다양한 혜택을 받으실 수 있습니다.</p>
        <a @click="openSignup">회원가입 하기 <i></i></a>
      </div>
      <div class="login_tab">
        <ul class="login_tabMenu">
          <li v-for="tab in userTypeTabs">
            <a @click="changeuserTypeTab(tab.idx)" :class="currentUsertype === tab.idx ? 'active' : ''">{{ tab.name }}</a>
          </li>
        </ul>
        <div class="login_tabPanel" :class="currentUsertype === 1 ? 'active' : ''" id="login_tab01">
          <div class="member">
            <div class="form_wrap">
              <p class="title">아이디</p>
              <input type="text" placeholder="아이디 입력" v-model="username">
            </div>
            <div class="form_wrap">
              <p class="title">비밀번호</p>
              <input type="password" placeholder="비밀번호 입력" v-model="pwd">
            </div>
            <button type="button" @click="login">로그인</button>
            <div class="find_wrap">
              <div class="chk_wrap">
                <input type="checkbox" id="save" name="save" v-model="isSaveUsername">
                <label for="save" class="chk_btn">
                    <span>아이디 저장</span>
                </label>
              </div>
              <div class="find_box">
                  <a href="" style="display:none;">아이디 찾기</a>
                  <a href="" style="display:none;">비밀번호 찾기</a>
                  <a @click="openSignup">회원가입</a>
              </div>
            </div>
            <div class="simple">
              <h5>SNS 간편 로그인</h5>
              <div class="btn_wrap">
                <button type="button" class="kakao" @click="kakaoLogin">
                  카카오로 시작하기
                </button>
                <button type="button" class="naver" @click="naverLogin">
                  네이버로 시작하기
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="login_tabPanel" :class="currentUsertype === 2 ? 'active' : ''" id="login_tab02">
          <div class="member not">
            <div class="form_wrap">
              <p class="title">주문자명</p>
              <input type="text" placeholder="주문자명 입력" v-model="nonUserName">
            </div>
            <div class="form_wrap">
              <p class="title">휴대폰 번호</p>
              <input type="text" placeholder="ex. 010-1234-5678" v-model="phoneNum">
            </div>
            <div class="form_wrap">
              <p class="title">주문 비밀번호</p>
              <input type="text" placeholder="주문 비밀번호 입력" v-model="orderNum">
            </div>
            <button type="button" class="btn_login" @click="nonUserLogin">로그인</button>
            <div class="find_wrap">
              <div class="chk_wrap" style="display:none;">
                <input type="checkbox" id="pass_find" name="pass_find">
                <label for="pass_find" class="chk_btn">
                  <span>주문비밀번호 찾기</span>
                </label>
              </div>
              <div class="find_box">
                <a href="" style="display:none;">아이디 찾기</a>
                <a href="" style="display:none;">비밀번호 찾기</a>
                <a @click="openSignup">회원가입</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <NonUserLoginModal v-if="isSignup" @closeModal="closeModal"/>
  <UserLoginModalForm v-if="loginModal" @closeModal="closeLoginModal"/>
</template>
<script>
import { mapActions } from 'vuex';
import NonUserLoginModal from './NonUserLoginModal.vue';
import UserLoginModalForm from './UserLoginModalForm.vue';

const accountModule = 'accountModule'

export default {
  components: {
    NonUserLoginModal,
    UserLoginModalForm
  },

  data () {
    return {
      username: '',
      pwd: '',
      isSaveUsername: false,

      nonUserName: '',
      phoneNum: '',
      orderNum: '',

      isSignup: false,
      loginModal: false,

      userTypeTabs: [
        {idx: 1, name: '회원'},
        {idx: 2, name: '비회원'}
      ],
      currentUsertype: 1
    }
  },

  methods: {
    ...mapActions(accountModule, [
      'requestLogin',
      'requestNonUserLogin',
      'requestKakaoOauthRedirectUrl',
      'requestNaverOauthRedirectUrl'
    ]),

    openSignup() {
      this.$router.push({ name: 'AccountSignupPage' })
    },

    closeModal() {
      this.isSignup = false
    },

    closeLoginModal() {
      this.loginModal = false
    },

    changeuserTypeTab(idx) {
      this.currentUsertype = idx
    },

    async login() {
      const isLoginPage = true
      const {username, pwd, isSaveUsername} = this
      if (username == '' || pwd == '') {
        this.$openModal('alertModal', {
          message: '정보를 모두 입력해주세요.'
        })
        return
      }
      if (await this.requestLogin({username, pwd, isSaveUsername, isLoginPage})) {
        this.$router.push({ name: 'home' })
      } else {
        this.$openModal('alertModal', {
          message: '잘못된 정보입니다.'
        })
      }
    },

    async nonUserLogin () {
      const {nonUserName, phoneNum, orderNum} = this
      console.log(nonUserName, phoneNum, orderNum)
      if (nonUserName == '' || phoneNum == '' || orderNum == '') {
        this.$openModal('alertModal', {
          message: '정보를 모두 입력해주세요.'
        })
        return
      }
      if (await this.requestNonUserLogin({nonUserName, phoneNum, orderNum})) {
        this.$router.push({ name: 'home' })
      } else {
        this.$openModal('alertModal', {
          message: '잘못된 정보입니다.'
        })
      }
    },

    async kakaoLogin() {
      this.requestKakaoOauthRedirectUrl()
    },

    async naverLogin() {
      this.requestNaverOauthRedirectUrl()
    }
  },

  mounted() {
    const savedUsername = localStorage.getItem('usernameSave')
    if (savedUsername) {
      this.username = savedUsername
      this.isSaveUsername = true
    }
  }
}
</script>
<style lang="">
    
</style>